<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFullscreenOff_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m17.36 8.407 3.52 1.183a.642.642 0 0 1-.205 1.254H13.8a.644.644 0 0 1-.644-.644V3.325a.644.644 0 0 1 1.254-.205l1.183 3.519 3.573-3.573a1.25 1.25 0 1 1 1.768 1.768zM3.326 13.156H10.2c.356 0 .644.288.644.644v6.875a.644.644 0 0 1-1.254.205l-1.183-3.519-3.573 3.573a1.25 1.25 0 0 1-1.768-1.768l3.573-3.573-3.52-1.183a.642.642 0 0 1 .206-1.254"
        clip-rule="evenodd"
    />
</svg>
